const zhMessages = {
  "nav": {
    "home": "首页",
    "start": "开始使用",
    "learning": "学习中心",
    "support": "家长支持",
    "buy": "购买",
    "about": "关于我们",
    "admin": "管理后台"
  },
  "hero": {
    "title": "GENIUS AI",
    "subtitle": "孩子的智能语言学习伙伴",
    "description": "专为4-13岁儿童设计的AI语言学习机器人，安全、有趣、有效",
    "cta": "开始使用",
    "learnMore": "了解更多"
  },
  "start": {
    "hero": {
      "title": "开始使用GENIUS AI",
      "subtitle": "产品说明书 + 产品介绍 + 使用方式 + 介绍视频"
  },
  "product": {
      "title": "产品介绍",
      "description": "专为4-13岁儿童设计的智能语言学习机器人，采用可爱的圆形设计，配备安全的硅胶外壳。"
    },
    "setup": {
      "title": "设置指南",
      "step1": {
        "title": "开箱",
        "description": "打开包装，取出GENIUS AI设备"
      },
      "step2": {
        "title": "开机",
        "description": "长按电源键3秒开机"
      },
      "step3": {
        "title": "连接",
        "description": "按照屏幕提示连接WiFi"
      },
      "step4": {
        "title": "设置",
        "description": "创建家长账户并设置儿童档案"
      }
    },
    "videos": {
      "title": "视频教程"
    },
    "faq": {
      "title": "常见问题"
    },
    "features": {
      "design": "专为4-13岁儿童设计",
      "safety": "安全的硅胶外壳", 
      "ai": "AI老师Lily陪伴"
    },
    "showcase": {
      "title": "GENIUS AI 产品展示"
    },
    "videoList": {
      "intro": "产品介绍视频",
      "setup": "首次设置教程",
      "features": "基础功能介绍"
    },
    "watchVideo": "观看视频",
    "faqItems": {
      "charge": {
        "question": "如何为设备充电？",
        "answer": "使用附带的磁吸式充电器，将充电器靠近设备底部即可自动吸附充电。"
      },
      "age": {
        "question": "设备适合几岁的孩子使用？",
        "answer": "GENIUS AI专为4-13岁儿童设计，根据不同年龄段提供相应的学习内容。"
      },
      "setup": {
        "question": "如何设置设备？",
        "answer": "请参考开始使用页面的设置指南，或观看视频教程。"
      }
    },
    "cta": {
      "title": "准备好开始了吗？",
      "subtitle": "立即购买GENIUS AI，让孩子开始快乐的语言学习之旅",
      "buy": "立即购买",
      "learnMore": "了解更多"
    }
  },
  "learning": {
    "hero": {
      "title": "学习中心",
      "subtitle": "学习功能 + AI老师 + 教育框架 + 素材下载"
    },
    "lily": {
      "title": "AI老师Lily",
      "description": "Lily是一位可爱的AI老师，她温柔耐心，善于与孩子互动，能够根据每个孩子的特点提供个性化的学习体验。"
    },
    "framework": {
      "title": "教育框架"
    },
    "materials": {
      "title": "学习素材下载",
      "description": "我们提供丰富的可下载学习素材，帮助孩子离线学习和家长辅助教学。"
    },
    "cta": {
      "title": "在线体验",
      "description": "立即体验GENIUS AI的强大功能，感受智能学习的魅力！",
      "button": "立即体验"
    },
    "lilyFeatures": [
      "语音对话",
      "个性化教学", 
      "进度跟踪",
      "情感陪伴"
    ],
    "lilyName": "Lily老师",
    "learningFeatures": [
      {
        "title": "词汇学习",
        "description": "通过图片、发音和互动游戏学习新词汇"
      },
      {
        "title": "对话练习", 
        "description": "与AI老师Lily进行真实场景对话练习"
      },
      {
        "title": "故事阅读",
        "description": "丰富的双语故事库，提升阅读兴趣"
      },
      {
        "title": "互动游戏",
        "description": "通过趣味游戏巩固学习成果"
      }
    ],
    "ageGroups": [
      {
        "age": "4-6岁",
        "title": "启蒙阶段",
        "description": "基础词汇学习与发音练习，通过儿歌和简单故事启蒙"
      },
      {
        "age": "6-10岁", 
        "title": "基础阶段",
        "description": "日常对话练习与情景模拟，扩展词汇量和语法知识"
      },
      {
        "age": "10-13岁",
        "title": "进阶阶段", 
        "description": "进阶语言学习与文化探索，培养独立思考和表达能力"
      }
    ],
    "downloads": [
      {
        "name": "学习卡片 (PDF)",
        "description": "可打印的学习卡片，帮助孩子离线学习"
      },
      {
        "name": "练习册 (PDF)",
        "description": "配套练习册，巩固学习成果"
      },
      {
        "name": "Lily老师壁纸 (JPG)",
        "description": "可爱的Lily老师壁纸，让孩子更喜爱"
      }
    ],
    "downloadButton": "下载",
    "startButton": "开始使用"
  },
  "support": {
    "hero": {
      "title": "家长支持",
      "subtitle": "家长指南 + 帮助中心 + 互动指导"
    },
    "philosophy": {
      "title": "教育理念",
      "vision": {
        "title": "教育愿景",
        "description": "让每个4-13岁的孩子都能享受到安全、有趣、个性化的语言学习体验"
      },
      "safety": {
        "title": "安全保障",
        "description": "设备采用食品级硅胶材质，无蓝光护眼屏幕，严格控制内容"
      },
      "effectiveness": {
        "title": "学习效果",
        "description": "通过AI个性化教学和游戏化互动，显著提升孩子的语言学习兴趣"
      }
    },
    "control": {
      "title": "家长支持功能"
    },
    "experts": {
      "title": "专家推荐"
    },
    "faq": {
      "title": "常见问题"
    },
    "contact": {
      "title": "联系我们"
    },
    "tips": {
      "title": "互动建议"
    },
    "parentFeatures": [
      {
        "title": "使用时间建议",
        "description": "建议每日使用时间，保护孩子视力健康"
      },
      {
        "title": "学习进度查看",
        "description": "查看孩子的学习进度和成绩"
      },
      {
        "title": "内容安全过滤",
        "description": "确保所有学习内容都适合儿童"
      },
      {
        "title": "设备管理",
        "description": "通过手机APP管理设备设置"
      },
      {
        "title": "学习报告",
        "description": "定期生成详细的学习报告"
      },
      {
        "title": "目标设定",
        "description": "为孩子设定学习目标和奖励"
      }
    ],
    "expertTestimonials": [
      {
        "title": "儿童心理学专家",
        "quote": "GENIUS AI的设计充分考虑了儿童的认知发展特点，其互动方式能有效激发孩子的学习兴趣。"
      },
      {
        "title": "语言教育学教授",
        "quote": "这款机器人为儿童提供了沉浸式的语言环境，是传统教学的有力补充。"
      }
    ],
    "faqItems": [
      {
        "question": "如何设置设备？",
        "answer": "请参考开始使用页面的设置指南，或观看视频教程。"
      },
      {
        "question": "如何与孩子互动？",
        "answer": "建议家长陪伴孩子一起使用设备，鼓励孩子与Lily老师对话，定期查看学习进度。"
      },
      {
        "question": "如何查看学习进度？",
        "answer": "通过设备屏幕可以查看孩子的学习进度和成绩。"
      },
      {
        "question": "如何设置使用时间？",
        "answer": "建议家长根据孩子年龄合理安排使用时间，保护孩子视力健康。"
      },
      {
        "question": "如何联系客服？",
        "answer": "您可以通过邮箱、电话或WhatsApp联系我们的客服团队，我们24小时为您服务。"
      }
    ],
    "contactInfo": {
      "email": "邮箱",
      "phone": "电话",
      "serviceTime": "服务时间",
      "serviceHours": "周一至周五 9:00-18:00"
    },
    "interactionTips": [
      {
        "title": "共同学习",
        "content": "每天花15-30分钟与孩子一起使用GENIUS AI，参与他们的学习过程。"
      },
      {
        "title": "鼓励表达",
        "content": "鼓励孩子大胆开口说，即使有错误也要给予积极反馈。"
      },
      {
        "title": "创造语境",
        "content": "在日常生活中创造语言使用场景，如一起看双语动画、玩角色扮演游戏。"
      },
      {
        "title": "耐心引导",
        "content": "当孩子遇到困难时，给予耐心指导，而不是直接给出答案。"
      }
    ]
  },
  "buy": {
    "hero": {
      "title": "选择您的套餐",
      "subtitle": "选择最适合您孩子的学习套餐，开启智能学习之旅"
    },
    "plans": {
      "title": "选择套餐"
    },
    "package": {
      "title": "GENIUS AI",
      "subtitle": "完整学习功能",
      "price": "Rp 499,000",
      "originalPrice": "Rp 899,000",
      "discount": "限时优惠",
      "savings": "立省 Rp 400,000",
      "features": [
        "完整学习功能",
        "AI老师Lily",
        "所有学习内容",
        "终身免费使用",
        "安全设计"
      ],
      "buyButton": "立即购买"
    },
    "showcase": {
      "title": "产品展示"
    },
    "benefits": {
      "discount": {
        "title": "🎁 限时优惠",
        "description": "现在购买享受限时优惠价格，立省 Rp 400,000！"
      },
      "shipping": {
        "title": "🚚 免费配送",
        "description": "印尼全境包邮，7天内发货，支持货到付款。"
      },
      "warranty": {
        "title": "🛡️ 质量保证",
        "description": "1年质保，30天无理由退换，让您购买无忧。"
      }
    },
    "process": {
      "title": "购买流程",
      "steps": [
        {
          "title": "选择套餐",
          "description": "选择适合您孩子的学习套餐"
        },
        {
          "title": "填写信息",
          "description": "填写收货地址和联系方式"
        },
        {
          "title": "支付订单",
          "description": "选择支付方式完成付款"
        },
        {
          "title": "开始学习",
          "description": "收到产品后开始学习之旅"
        }
      ]
    },
    "cta": {
      "title": "立即购买 GENIUS AI",
      "subtitle": "现在购买享受限时优惠，让孩子开始快乐的语言学习之旅！",
      "buyButton": "立即购买 - Rp 499,000",
      "learnMoreButton": "了解更多"
    }
  },
  "about": {
    "hero": {
      "title": "关于我们",
      "subtitle": "致力于让儿童语言学习变得更有趣、更安全、更有效"
    },
    "mission": {
      "title": "使命",
      "description": "让每个4-13岁的孩子都能享受到安全、有趣、个性化的语言学习体验，通过AI技术让学习变得更有趣、更有效。"
    },
    "vision": {
      "title": "愿景",
      "description": "成为印尼领先的儿童智能语言学习解决方案提供商，推动教育科技的创新与发展，让每个孩子都能快乐学习。"
    },
    "team": {
      "title": "核心团队"
    },
    "value": {
      "title": "核心价值观"
    },
    "history": {
      "title": "发展历程"
    },
    "partner": {
      "title": "合作伙伴"
    },
    "contact": {
      "title": "联系我们"
    },
    "cta": {
      "title": "加入我们的使命",
      "description": "让我们一起为儿童创造更好的学习体验",
      "buttonPrimary": "联系我们",
      "buttonSecondary": "了解更多"
    },
    "teamMembers": [
      {
        "name": "张博士",
        "role": "CEO & 创始人",
        "description": "儿童教育专家，拥有15年教育行业经验，专注于AI教育技术研发。",
        "avatar": "👨‍💼"
      },
      {
        "name": "李工程师",
        "role": "CTO & 技术总监",
        "description": "AI技术专家，前Google工程师，专注于儿童安全AI技术开发。",
        "avatar": "👨‍💻"
      },
      {
        "name": "王设计师",
        "role": "设计总监",
        "description": "儿童产品设计专家，专注于儿童友好的界面设计和用户体验。",
        "avatar": "👩‍🎨"
      }
    ],
    "values": [
      {
        "icon": "🛡️",
        "title": "安全第一",
        "description": "儿童安全是我们最重要的考虑，所有产品都经过严格的安全测试。"
      },
      {
        "icon": "👥",
        "title": "用户至上",
        "description": "以孩子和家长的需求为中心，不断优化产品体验。"
      },
      {
        "icon": "🚀",
        "title": "持续创新",
        "description": "不断探索新技术，将AI、语音识别等前沿技术融入教育。"
      },
      {
        "icon": "🤝",
        "title": "团队合作",
        "description": "相信团队的力量，通过协作创造更好的产品。"
      }
    ],
    "timeline": [
      {
        "year": "2023",
        "title": "公司成立",
        "description": "公司成立，专注于儿童AI教育技术研发，获得天使轮投资。"
      },
      {
        "year": "2024",
        "title": "产品开发",
        "description": "完成A轮融资，团队扩展到50人，GENIUS AI产品原型开发完成。"
      },
      {
        "year": "2024",
        "title": "产品发布",
        "description": "GENIUS AI产品正式发布，获得印尼用户广泛好评，用户数突破1万。"
      },
      {
        "year": "未来",
        "title": "扩展计划",
        "description": "计划扩展到更多东南亚国家，成为区域领先的儿童智能学习平台。"
      }
    ],
    "partners": [
      {
        "name": "印尼教育集团",
        "description": "与印尼最大的教育集团合作，为学校提供定制化解决方案。"
      },
      {
        "name": "雅加达科技园",
        "description": "入驻雅加达科技园，享受政策支持和产业资源。"
      },
      {
        "name": "零售合作伙伴",
        "description": "与印尼主要零售商合作，扩大产品销售渠道。"
      }
    ],
    "contactInfo": {
      "email": "邮箱",
      "phone": "电话",
      "address": "地址",
      "location": "Kirana Three Office Tower, 雅加达",
      "viewOnMaps": "在Google地图中查看"
    }
  },
  "features": {
    "title": "为什么选择GENIUS AI？",
    "lily": {
      "title": "AI老师Lily",
      "description": "可爱的AI学习伙伴，温柔耐心，善于与孩子互动"
    },
    "safety": {
      "title": "安全可靠",
      "description": "专为儿童设计的安全功能，食品级硅胶材质，家长放心"
    },
    "fun": {
      "title": "趣味学习",
      "description": "通过游戏化方式学习语言，让孩子爱上学习"
    }
  },
  "testimonials": {
    "title": "家长推荐",
    "sarah": {
      "name": "Sarah妈妈",
      "location": "雅加达",
      "quote": "我的孩子非常喜欢Lily老师，学习效果很好！设备很安全，我完全放心让孩子使用。"
    },
    "michael": {
      "name": "Michael爸爸",
      "location": "泗水",
      "quote": "GENIUS AI让我的孩子对学习中文产生了浓厚兴趣，每天都很期待和Lily老师对话。"
    }
  },
  "cta": {
    "title": "准备好开始了吗？",
    "subtitle": "立即购买GENIUS AI，让孩子开始快乐的语言学习之旅",
    "button": "立即购买",
    "learnMore": "了解更多"
  },
  "footer": {
    "description": "GENIUS AI - 4-13岁儿童的智能语言学习机器人",
    "rights": "版权所有 © 2024 GENIUS AI",
    "tagline": "让学习变得更有趣。",
    "developedBy": "由 Infant.AI 公司开发",
    "privacyPolicy": "隐私政策",
    "termsOfService": "服务条款",
    "cookiePolicy": "Cookie 政策"
  }
}

export default zhMessages
